import React from 'react';
import Loading from '../helpers/Loading';

const LoadingWrapper = ({ children, show, label, className, size, color }) => {
    if (show) {
        return <Loading label={label} className={className} size={size} color={color} />;
    } else {
        return children;
    }
};

export default LoadingWrapper;



// WEBPACK FOOTER //
// ./src/components/hocs/LoadingWrapper.js